import React, { Component } from 'react';
import './App.css';
import { hunter, footballCoaches, afterTheFiring, sportsSnapshots, twitter } from './data';

const TABS = ['Overview', 'Football', 'Other Sports', 'After the Firing', 'Twitter / X'];

const pct = c => c.wins / (c.wins + c.losses);

const Verify = () => <span className="verify" title="Figure needs verification">verify</span>;

const Overview = () => (
  <section>
    <h2>{hunter.name}</h2>
    <p className="sub">{hunter.title}</p>
    <ul className="facts">{hunter.facts.map(f => <li key={f}>{f}</li>)}</ul>
  </section>
);

const Football = () => (
  <section>
    <h2>Football head coaches (win % at Arkansas)</h2>
    <div className="bars">
      {footballCoaches.map(c => (
        <div className="bar-row" key={c.name}>
          <div className="bar-label">{c.name} <small>{c.years}</small></div>
          <div className="bar-track">
            <div className={'bar-fill' + (c.ad.includes('Yurachek') ? ' yur' : '')} style={{ width: (pct(c) * 100) + '%' }} />
          </div>
          <div className="bar-val">{c.wins}–{c.losses} ({Math.round(pct(c) * 100)}%)</div>
        </div>
      ))}
    </div>
    <p className="legend"><span className="sw yur" /> Yurachek era &nbsp; <span className="sw" /> Earlier</p>
    <table>
      <thead><tr><th>Coach</th><th>Years</th><th>Exit</th><th>Notes</th></tr></thead>
      <tbody>
        {footballCoaches.map(c => (
          <tr key={c.name}><td>{c.name}</td><td>{c.years}</td><td>{c.exit}</td><td>{c.note} {c.verify && <Verify />}</td></tr>
        ))}
      </tbody>
    </table>
  </section>
);

const Others = () => (
  <section>
    <h2>Other sports: before and during Yurachek</h2>
    <div className="cards">
      {sportsSnapshots.map(s => (
        <div className="card" key={s.sport}>
          <h3>{s.sport} {s.verify && <Verify />}</h3>
          <p><b>Before:</b> {s.before}</p>
          <p><b>During:</b> {s.during}</p>
          <p><b>Verdict:</b> {s.verdict}</p>
        </div>
      ))}
    </div>
  </section>
);

class After extends Component {
  state = { sport: 'All' };
  render() {
    const sports = ['All', ...new Set(afterTheFiring.map(a => a.sport))];
    const rows = afterTheFiring.filter(a => this.state.sport === 'All' || a.sport === this.state.sport);
    return (
      <section>
        <h2>What happened after a coach left</h2>
        <p className="sub">About 40 years. Each firing is an event between two eras.</p>
        <div className="filters">
          {sports.map(s => (
            <button key={s} className={s === this.state.sport ? 'on' : ''} onClick={() => this.setState({ sport: s })}>{s}</button>
          ))}
        </div>
        <ol className="timeline">
          {rows.map(a => (
            <li key={a.sport + a.coach}>
              <div className="event">
                <span className="event-year">{a.year}</span>
                <span className="event-text">{a.coach} out <small>· {a.sport}</small></span>
              </div>
              <div className={'era ' + a.outlook}>
                <span className="tag">{a.outlook === 'good' ? 'Program improved' : a.outlook === 'bad' ? 'Program declined' : 'Mixed'}</span>
                <p>{a.after} {a.verify && <Verify />}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
    );
  }
}

const Twitter = () => (
  <section>
    <h2>Twitter / X activity</h2>
    <p className="note">{twitter.note}</p>
    <ul className="links">
      {twitter.searches.map(s => <li key={s.url}><a href={s.url} target="_blank" rel="noopener noreferrer">{s.label}</a></li>)}
    </ul>
    <div className="cards">
      {twitter.themes.map(t => <div className="card" key={t.theme}><h3>{t.theme}</h3><p>{t.detail}</p></div>)}
    </div>
  </section>
);

class App extends Component {
  state = { tab: TABS[0] };
  render() {
    const { tab } = this.state;
    const View = { Overview, Football, 'Other Sports': Others, 'After the Firing': After, 'Twitter / X': Twitter }[tab];
    return (
      <div className="App">
        <header>
          <h1>Fire Hunter?</h1>
          <p>Arkansas Razorbacks athletic director Hunter Yurachek: the record, the results, the reaction.</p>
        </header>
        <nav>
          {TABS.map(t => <button key={t} className={t === tab ? 'on' : ''} onClick={() => this.setState({ tab: t })}>{t}</button>)}
        </nav>
        <main><View /></main>
        <footer>
          Data compiled from public information and may contain errors; items tagged <Verify /> need checking against official sources.
        </footer>
      </div>
    );
  }
}

export default App;
